import BaseNotificationHandler from './baseHandler.js';

/**
 * Appointment Notification Handler
 * Handles all appointment-related notifications
 */
class AppointmentHandler extends BaseNotificationHandler {
  getIcon(notification, parsedData) {
    return "📅";
  }

  getMainText(notification, parsedData) {
    const senderName = this.getSenderInfo(notification, parsedData) || 'Someone';
    const petName = parsedData.pet_name;
    const notificationType = notification.type;

    switch (notificationType) {
      case "appointment_created":
        return petName
          ? `${senderName} created an appointment for ${petName}`
          : `${senderName} created an appointment for your pet`;
      case "appointment_updated":
        return petName
          ? `${senderName} updated ${petName}'s appointment`
          : `${senderName} updated an appointment`;
      case "appointment_canceled":
        return petName
          ? `${senderName} canceled ${petName}'s appointment`
          : `${senderName} canceled an appointment`;
      case "appointment_restored":
        return petName
          ? `${senderName} restored ${petName}'s appointment`
          : `${senderName} restored an appointment`;
      case "appointment_status_changed":
        return petName
          ? `${senderName} changed ${petName}'s appointment status`
          : `${senderName} changed appointment status`;
      default:
        return `${senderName} updated an appointment`;
    }
  }

  getDetails(notification, parsedData) {
    const details = [];

    if (parsedData.pet_name) {
      details.push(`Pet: ${parsedData.pet_name}`);
    }
    if (parsedData.clinic_name) {
      details.push(`Clinic: ${parsedData.clinic_name}`);
    }
    if (parsedData.appointment_date) {
      try {
        const date = new Date(parsedData.appointment_date);
        if (!isNaN(date.getTime())) {
          const formattedDate = date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          });
          const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit'
          });
          details.push(`${formattedDate} at ${formattedTime}`);
        }
      } catch (e) {
        // Ignore date parsing errors
      }
    }
    if (parsedData.status) {
      details.push(`Status: ${parsedData.status}`);
    }

    return details;
  }

  getThumbnail(notification, parsedData) {
    // For appointments, try to get pet image
    if (parsedData.pet_image) return parsedData.pet_image;
    if (parsedData.image) return parsedData.image;
    if (parsedData.data?.pet_image) return parsedData.data.pet_image;
    return super.getThumbnail(notification, parsedData);
  }

  handleClick(notification, parsedData, navigate, onClose, userType = null) {
    const appointmentId = parsedData.appointment_id || notification.target_id;
    const actionUrl = this.getActionUrl(notification, parsedData);

    if (appointmentId) {
      sessionStorage.setItem('highlightAppointmentId', appointmentId.toString());
      
      // If user is a pet guardian or service provider, redirect to their dashboard appointments tab
      if (userType === 'PET_GUARDIAN' || userType === 'SERVICE_PROVIDER') {
        const dashboardUrl = userType === 'SERVICE_PROVIDER'
          ? '/medical/dashboard/petshopowner?tab=appointments'
          : '/medical/dashboard/petguardian?tab=appointments';
        navigate(dashboardUrl);
        if (onClose) onClose();
      } else {
        // For clinic staff, navigate to clinic redirect to resolve clinic ID
        navigate('/medical/clinic/redirect-to-clinic');
        if (onClose) onClose();
      }
    } else if (actionUrl) {
      if (actionUrl.startsWith('http://') || actionUrl.startsWith('https://')) {
        window.location.href = actionUrl;
      } else {
        navigate(actionUrl);
      }
      if (onClose) onClose();
    }
  }
}

export default AppointmentHandler;

